// extracted by css-extract-rspack-plugin
module.exports =  {"marginSidebar":"Layout__marginSidebar--Shung","main":"Layout__main--xf9D4","base":"Layout__base--iTaPo"};